import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: '',
      redirect: '/login',
      component: resolve => {
        require(['@/components/pages/login/Login.vue'], resolve)
      }
    },
    { // 登录页
      path: '/login',
      name: 'Login',
      component: resolve => {
        require(['@/components/pages/login/Login.vue'], resolve)
      }
    },
    { // 主内容组件
      path: '/mainContainer',
      name: 'MainContainer',
      redirect: '/home',
      component: resolve => {
        require(['@/components/pages/main/MainContainer.vue'], resolve)
      },
      children: [
        { // 首页
          path: '/home',
          name: 'Home',
          component: resolve => {
            require(['@/components/pages/home/Home.vue'], resolve)
          }
        },
        { // 栏目设置
          path: '/columnSet',
          name: 'ColumnSet',
          component: resolve => {
            require(['@/components/pages/column-set/ColumnSet.vue'], resolve)
          }
        },
        { // 角色设置--组织架构
          path: '/framework',
          name: 'Framework',
          component: resolve => {
            require(['@/components/pages/role-set/framework/Framework.vue'], resolve)
          }
        },
        { // 角色设置--流程设置
          path: '/flowSet',
          name: 'FlowSet',
          component: resolve => {
            require(['@/components/pages/role-set/flow-set/FlowSet.vue'], resolve)
          }
        },
        { // 授权管理--授权申请
          path: '/accreditApply',
          name: 'AccreditApply',
          component: resolve => {
            require(['@/components/pages/accredit-manage/accredit-apply/AccreditApply.vue'], resolve)
          }
        },
        { // 授权管理--授权申请--申请审核
          path: '/applyAudit',
          name: 'ApplyAudit',
          component: resolve => {
            require(['@/components/pages/accredit-manage/accredit-apply/ApplyAudit.vue'], resolve)
          }
        },
        { // 授权管理--系统授权
          path: '/systemAccredit',
          name: 'SystemAccredit',
          component: resolve => {
            require(['@/components/pages/accredit-manage/system-accredit/systemAccredit.vue'], resolve)
          }
        },
        { // 授权管理--授权列表
          path: '/accreditList',
          name: 'AccreditList',
          component: resolve => {
            require(['@/components/pages/accredit-manage/accredit-list/AccreditList.vue'], resolve)
          }
        },
        { // 授权管理--授权列表--会员列表
          path: '/menberList',
          name: 'MenberList',
          component: resolve => {
            require(['@/components/pages/accredit-manage/accredit-list/MenberList.vue'], resolve)
          }
        },
        { // 会员管理--小程序会员
          path: '/appletMenber',
          name: 'AppletMenber',
          component: resolve => {
            require(['@/components/pages/menber-manage/applet-menber/AppletMenber.vue'], resolve)
          }
        },
        { // 会员管理--小程序会员--会员详情
          path: '/appletMenberDetail',
          name: 'AppletMenberDetail',
          component: resolve => {
            require(['@/components/pages/menber-manage/applet-menber/AppletMenberDetail.vue'], resolve)
          }
        },
        { // 会员管理--湾潮会员
          path: '/baytrendMenber',
          name: 'BaytrendMenber',
          component: resolve => {
            require(['@/components/pages/menber-manage/baytrend-menber/BaytrendMenber.vue'], resolve)
          }
        },
        { // 会员管理--湾潮会员--会员详情
          path: '/baytrendMenberDetail',
          name: 'BaytrendMenberDetail',
          component: resolve => {
            require(['@/components/pages/menber-manage/baytrend-menber/BaytrendMenberDetail.vue'], resolve)
          }
        },
        { // 表格页面
          path: '/tablePage',
          name: 'TablePage',
          component: resolve => {
            require(['@/components/pages/pages-view/TablePage.vue'], resolve)
          }
        },
        { // 文章管理-抓取设置
          path: '/captureSet',
          name: 'CaptureSet',
          component: resolve => {
            require(['@/components/pages/article-manege/capture-set/CaptureSet.vue'], resolve)
          }
        },
        { // 文章管理-抓取设置-编辑
          path: '/captureSetEdit',
          name: 'CaptureSetEdit',
          component: resolve => {
            require(['@/components/pages/article-manege/capture-set/CaptureSetEdit.vue'], resolve)
          }
        },
        { // 文章管理-抓取设置-文章列表
          path: '/captureArticleList',
          name: 'CaptureArticleList',
          component: resolve => {
            require(['@/components/pages/article-manege/capture-set/CaptureArticleList.vue'], resolve)
          }
        },
        { // 文章管理-抓取发布
          path: '/captureIssue',
          name: 'CaptureIssue',
          component: resolve => {
            require(['@/components/pages/article-manege/capture-issue/CaptureIssue.vue'], resolve)
          }
        },
        { // 文章管理-原创审核
          path: '/originalAudit',
          name: 'OriginalAudit',
          component: resolve => {
            require(['@/components/pages/article-manege/original-audit/OriginalAudit.vue'], resolve)
          }
        },
        { // 文章管理-原创设置
          path: '/originalSet',
          name: 'OriginalSet',
          component: resolve => {
            require(['@/components/pages/article-manege/original-set/OriginalSet.vue'], resolve)
          }
        },
        { // 文章管理-原创设置-发布列表
          path: '/originalIssueList',
          name: 'OriginalIssueList',
          component: resolve => {
            require(['@/components/pages/article-manege/original-set/OriginalIssueList.vue'], resolve)
          }
        },
        { // 文章管理-发布管理
          path: '/issueManage',
          name: 'IssueManage',
          component: resolve => {
            require(['@/components/pages/article-manege/issue-manage/IssueManage.vue'], resolve)
          }
        },
        { // 文章管理-发布管理-文章发布列表
          path: '/articleIssueList',
          name: 'ArticleIssueList',
          component: resolve => {
            require(['@/components/pages/article-manege/issue-manage/ArticleIssueList.vue'], resolve)
          }
        },
        { // 文章管理-线上文章库
          path: '/onlineArticle',
          name: 'OnlineArticle',
          component: resolve => {
            require(['@/components/pages/article-manege/online-article/OnlineArticle.vue'], resolve)
          }
        },
        { // 文章管理-公众号文章
          path: '/officialAccountsArticle',
          name: 'OfficialAccountsArticle',
          component: resolve => {
            require(['@/components/pages/article-manege/official-accounts-article/OfficialAccountsArticle.vue'], resolve)
          }
        },
        { // 文章管理-公众号文章-文章列表
          path: '/officialArticleList',
          name: 'OfficialArticleList',
          component: resolve => {
            require(['@/components/pages/article-manege/official-accounts-article/OfficialArticleList.vue'], resolve)
          }
        },
        { // 文章管理-标签管理
          path: '/articleLabelManage',
          name: 'ArticleLabelManage',
          component: resolve => {
            require(['@/components/pages/article-manege/label-manage/ArticleLabelManage.vue'], resolve)
          }
        },
        { // 文章列表
          path: '/articleList',
          name: 'ArticleList',
          component: resolve => {
            require(['@/components/pages/article-manege/ArticleList.vue'], resolve)
          }
        },
        { // 文章编辑/审核
          path: '/articleEdit',
          name: 'ArticleEdit',
          component: resolve => {
            require(['@/components/pages/article-manege/ArticleEdit.vue'], resolve)
          }
        },
        { // 文章推荐-位置设置
          path: '/positionSet',
          name: 'PositionSet',
          component: resolve => {
            require(['@/components/pages/article-recommend/position-set/PositionSet.vue'], resolve)
          }
        },
        { // 文章推荐-位置设置-添加/编辑
          path: '/advPositionForm',
          name: 'AdvPositionForm',
          component: resolve => {
            require(['@/components/pages/article-recommend/position-set/AdvPositionForm.vue'], resolve)
          }
        },
        { // 文章推荐-推荐列表
          path: '/recommendList',
          name: 'RecommendList',
          component: resolve => {
            require(['@/components/pages/article-recommend/recommend-list/RecommendList.vue'], resolve)
          }
        },
        { // 文章推荐-推荐列表-文章列表
          path: '/recommendArticles',
          name: 'RecommendArticles',
          component: resolve => {
            require(['@/components/pages/article-recommend/recommend-list/RecommendArticles.vue'], resolve)
          }
        },
        { // 小程序管理-商品列表-凤凰社
          path: '/goodsListfhs',
          name: 'GoodsListfhs',
          component: resolve => {
            require(['@/components/pages/applet-manage/goods-list/GoodsListfhs.vue'], resolve)
          }
        },
        { // 小程序管理-商品列表-卓悦惠
          path: '/goodsListzyh',
          name: 'GoodsListzyh',
          component: resolve => {
            require(['@/components/pages/applet-manage/goods-list/GoodsListzyh.vue'], resolve)
          }
        },
        { // 小程序管理-商品列表-米链优选
          path: '/goodsListmlyx',
          name: 'GoodsListmlyx',
          component: resolve => {
            require(['@/components/pages/applet-manage/goods-list/GoodsListmlyx.vue'], resolve)
          }
        },
        { // 小程序管理-商户列表-凤凰社
          path: '/storeListfhs',
          name: 'StoreListfhs',
          component: resolve => {
            require(['@/components/pages/applet-manage/store-list/StoreListfhs.vue'], resolve)
          }
        },
        { // 小程序管理-商户列表-卓悦惠
          path: '/storeListzyh',
          name: 'StoreListzyh',
          component: resolve => {
            require(['@/components/pages/applet-manage/store-list/StoreListzyh.vue'], resolve)
          }
        },
        { // 小程序管理-商户商品列表-卓悦惠
          path: '/storeGoodsListzyh',
          name: 'StoreGoodsListzyh',
          component: resolve => {
            require(['@/components/pages/applet-manage/store-list/store-goods-list/StoreGoodsListzyh.vue'], resolve)
          }
        },
        { // 小程序管理-商户列表-米链优选
          path: '/storeListmlyx',
          name: 'StoreListmlyx',
          component: resolve => {
            require(['@/components/pages/applet-manage/store-list/StoreListmlyx.vue'], resolve)
          }
        },
        { // 小程序管理-投放记录
          path: '/putinRecord',
          name: 'PutinRecord',
          component: resolve => {
            require(['@/components/pages/applet-manage/putin-record/PutinRecord.vue'], resolve)
          }
        },
        { // 小程序管理-商品分类
          path: '/productType',
          name: 'ProductType',
          component: resolve => {
            require(['@/components/pages/applet-manage/product-type/ProductType.vue'], resolve)
          }
        },
        { // 小程序管理-商品分类-添加商品
          path: '/addProduct',
          name: 'AddProduct',
          component: resolve => {
            require(['@/components/pages/applet-manage/product-type/AddProduct.vue'], resolve)
          }
        },
        { // 公众号托管-托管审核
          path: '/trusteeshipAudit',
          name: 'TrusteeshipAudit',
          component: resolve => {
            require(['@/components/pages/mpwx-trusteeship/trusteeship-audit/TrusteeshipAudit.vue'], resolve)
          }
        },
        { // 公众号托管-托管审核-审核
          path: '/trusteeshipAuditForm',
          name: 'TrusteeshipAuditForm',
          component: resolve => {
            require(['@/components/pages/mpwx-trusteeship/trusteeship-audit/TrusteeshipAuditForm.vue'], resolve)
          }
        },
        { // 公众号托管-添加托管
          path: '/addTrusteeship',
          name: 'AddTrusteeship',
          component: resolve => {
            require(['@/components/pages/mpwx-trusteeship/add-trusteeship/AddTrusteeship.vue'], resolve)
          }
        },
        { // 公众号托管-托管列表
          path: '/trusteeshipList',
          name: 'TrusteeshipList',
          component: resolve => {
            require(['@/components/pages/mpwx-trusteeship/trusteeship-list/TrusteeshipList.vue'], resolve)
          }
        },
        { // 公众号托管-托管列表-文章列表
          path: '/trusteeshipArticles',
          name: 'TrusteeshipArticles',
          component: resolve => {
            require(['@/components/pages/mpwx-trusteeship/trusteeship-list/TrusteeshipArticles.vue'], resolve)
          }
        },
        { // 提现审核
          path: '/withdrawalAudit',
          name: 'WithdrawalAudit',
          component: resolve => {
            require(['@/components/pages/withdrawal-audit/WithdrawalAudit.vue'], resolve)
          }
        },
        { // 提现审核-审核
          path: '/withdrawalAuditDetail',
          name: 'WithdrawalAuditDetail',
          component: resolve => {
            require(['@/components/pages/withdrawal-audit/WithdrawalAuditDetail.vue'], resolve)
          }
        },
      ]
    }
  ]
});

router.beforeEach((to, form, next) => {
  let token = window.localStorage.getItem('token');
  if(to.path === '/login') { 
    if(token) {
      return next({ path: '/home' });
    }
    return next();
  }
  if(token) {
    return next();
  } else {
    // 没有登录还想去其他页面，不可能，滚去登录页
    return next({ path: '/login' });
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js